import { render, staticRenderFns } from "./adminManage.vue?vue&type=template&id=b78288ee&scoped=true&"
import script from "./adminManage.vue?vue&type=script&lang=js&"
export * from "./adminManage.vue?vue&type=script&lang=js&"
import style0 from "./adminManage.vue?vue&type=style&index=0&id=b78288ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78288ee",
  null
  
)

export default component.exports